module.exports = __webpack_public_path__ + "static/media/option-4.b17291cd.ogg";